var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useCallback, useState } from 'react';
export function useForceUpdate() {
    var _a = __read(useState(Math.random()), 2), _ = _a[0], setNonce = _a[1];
    return useCallback(function () { return setNonce(Math.random()); }, []);
}
//# sourceMappingURL=useForceUpdate.js.map